// extracted by mini-css-extract-plugin
export default {"root":"IconGear_root__2TQwU","icon":"IconGear_icon__ZOFgG"};